export enum EFuelQuantityUnit {
  USG = 'USG',
  LTR = 'LTR',
  LBS = 'LBS',
  KGS = 'KGS',
}

export const FuelQuantityUnitValues = Object.values(EFuelQuantityUnit)

export const getFuelQuantityUnitIntl = (unit: EFuelQuantityUnit) => {
  switch (unit) {
    case EFuelQuantityUnit.LTR: {
      return 'liter'
    }
    case EFuelQuantityUnit.USG: {
      return 'gallon'
    }
    case EFuelQuantityUnit.KGS: {
      return 'kilogram'
    }
    case EFuelQuantityUnit.LBS: {
      return 'pound'
    }
    default: {
      return 'unknown'
    }
  }
}

export const convertFuelQuantityUnitValue = (
  value: number,
  from: EFuelQuantityUnit,
  to: EFuelQuantityUnit,
) => {
  if (from === to) return value

  const conversionFactors: {
    [key in EFuelQuantityUnit]: {
      [subKey in EFuelQuantityUnit]?: number
    }
  } = {
    [EFuelQuantityUnit.USG]: {
      [EFuelQuantityUnit.LTR]: 3.785_41,
      [EFuelQuantityUnit.LBS]: 6.7,
      [EFuelQuantityUnit.KGS]: 3.0391,
    },
    [EFuelQuantityUnit.LTR]: {
      [EFuelQuantityUnit.USG]: 1 / 3.785_41,
      [EFuelQuantityUnit.LBS]: 1.7704,
      [EFuelQuantityUnit.KGS]: 0.8033,
    },
    [EFuelQuantityUnit.LBS]: {
      [EFuelQuantityUnit.USG]: 1 / 6.7,
      [EFuelQuantityUnit.LTR]: 1 / 1.7704,
      [EFuelQuantityUnit.KGS]: 0.4536,
    },
    [EFuelQuantityUnit.KGS]: {
      [EFuelQuantityUnit.USG]: 1 / 3.0391,
      [EFuelQuantityUnit.LTR]: 1 / 0.8033,
      [EFuelQuantityUnit.LBS]: 1 / 0.4536,
    },
  }

  if (from === to) {
    return value
  }

  const factor = conversionFactors[from]?.[to]

  return factor ? value * factor : value
}
